import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=1ecb5c5c&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecb5c5c')) {
      api.createRecord('1ecb5c5c', component.options)
    } else {
      api.reload('1ecb5c5c', component.options)
    }
    module.hot.accept("./Accounts.vue?vue&type=template&id=1ecb5c5c&", function () {
      api.rerender('1ecb5c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/Accounts.vue"
export default component.exports